import React from 'react'
import './CompteView.scss'
import Compte from '../../../Page/Utilisateur/Compte'

export default class extends React.Component {

  constructor (props) {
    super(props)
  }
  render () {
    return <Compte/>
  }

}



// WEBPACK FOOTER //
// ./app/App/Page/Compte/Page/CompteView.js